import type { OrganizationProfile } from '../../../../Generated/OrganizationProfile.ts'
import { useSelector } from 'Flux/index.js'
import { createSelector } from '@reduxjs/toolkit'
import type { State } from 'Flux/Slice/index.js'
import { organizationSlice } from 'Flux/Slice/Organization/OrganizationSlice.js'

export const useGetOrganizationsSelector: () => OrganizationProfile[] = () => {
  return useSelector(getOrganizations)
}

export const useGetOrganizationsTotalSelector: () => number = () => {
  return useSelector(getOrganizationsTotal)
}

export const useGetOrganizationByIdSelector: (id: string) => OrganizationProfile | undefined = (id: string) => {
  return useSelector((state: typeof State) => state[organizationSlice.name].organizations[id])
}

const selectOrganizations = (state: typeof State) => state[organizationSlice.name].organizationsList

const selectOrganizationsTotal = (state: typeof State) => state[organizationSlice.name].total

export const getOrganizations = createSelector(selectOrganizations, (orgs) => [...orgs])

export const getOrganizationsTotal = createSelector(selectOrganizationsTotal, (total) => total)
